import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { GlobalContext } from "../../context/GlobalContext";
import Grid from "../Grid/Grid";
import Charts from "../Charts/Charts";
import formatNumber from "../../helpers/formatNumber";

const StockKeyFacts = ({ price, dividendyield }) => {
  return (
    <Grid>
      <div className="col-4 text-center">
        <p className="stockinfo-keyfacts-label">Aktienkurs</p>
        <p className="stockinfo-keyfacts-value">
          {formatNumber(price.toFixed(2))}
        </p>
      </div>
      <div className="col-4 text-center">
        <p className="stockinfo-keyfacts-label">Div.-Rendite</p>
        <p className="stockinfo-keyfacts-value">
          {dividendyield
            ? `${formatNumber((dividendyield * 100).toFixed(2))} %`
            : "-"}
        </p>
      </div>
      <div className="col-4 text-center">
        <p className="stockinfo-keyfacts-label">Dividende</p>
        <p className="stockinfo-keyfacts-value">
          {dividendyield
            ? `${formatNumber((price * dividendyield).toFixed(2))}`
            : "-"}
        </p>
      </div>
    </Grid>
  );
};

export default function StockInfo({ stockdata, releaseDate, noAccordion }) {
  const { isMobile } = React.useContext(GlobalContext);
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const data = React.useMemo(() => {
    if (stockdata) {
      const dataArray = Object.entries(stockdata?.history).map(
        ([key, value]) => ({
          date: key,
          value: parseFloat(value),
        })
      );
      dataArray?.push({
        date: releaseDate,
        value: stockdata?.price,
      });
      return dataArray;
    }
    return null;
  }, [stockdata, releaseDate]);

  if (noAccordion) {
    return (
      <div
        className="text-muted"
        style={{ marginLeft: "-20px", width: "110%" }}
      >
        <StockKeyFacts
          price={stockdata?.price}
          dividendyield={stockdata?.dividendyield}
        />

        <br />
        <Charts.Stock data={data} releaseDate={releaseDate} />
        <p className="stockinfo-meta text-muted">
          {`Zuletzt aktualisiert: ${moment(stockdata?.lastupdate)?.format(
            "DD.MM.YYYY"
          )}`}
        </p>
        <br />
      </div>
    );
  }

  return (
    <div
      id="accordion"
      className={`${!isMobile && "article-text"} ${
        isMobile ? "text-left" : "text-justify"
      } text-light bg-dark stockinfo`}
    >
      <div className="card bg-dark">
        <div
          className="card-header pointer"
          id="headingOne"
          data-toggle="collapse"
          data-target="#stockinformation"
          aria-expanded="true"
          aria-controls="stockinformation"
          aria-disabled="true"
          onClick={() => setIsCollapsed((prev) => !prev)}
        >
          <Grid className="text-muted d-flex align-items-center">
            <span className="col-10">Finanzübersicht</span>
            <span className="col-2 text-right">
              <FontAwesomeIcon
                icon={isCollapsed ? faCaretDown : faCaretUp}
                className="text-right"
              />
            </span>
          </Grid>
        </div>

        <div
          id="stockinformation"
          className="collapse text-muted show"
          aria-labelledby="headingOne"
          data-parent="#accordion"
        >
          <div className="text-muted">
            <StockKeyFacts
              price={stockdata?.price}
              dividendyield={stockdata?.dividendyield}
            />

            <br />
            <Charts.Stock data={data} releaseDate={releaseDate} />
            <p className="stockinfo-meta text-muted">
              {`Zuletzt aktualisiert: ${moment(stockdata?.lastupdate)?.format(
                "DD.MM.YYYY"
              )}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
